export default __webpack_public_path__ + "static/media/info-icon-sky.0c4cc5d2.svg";